import PetsIcon from "@mui/icons-material/Pets";
import usePrimaryColor from "../../../../../hooks/usePrimaryColor";

export const StepIcon = (props) => {
  const { active, completed } = props;
  const color = usePrimaryColor();
  return (
    <PetsIcon
      sx={{
        color: active || completed ? color : "grey",
      }}
    />
  );
};
